import { useMemo } from 'react';
import { Badge } from 'reactstrap';

export interface BadgeStateProps {
  status: 'published' | 'finished';
  text: string;
}
export default function BadgeState({ status, text }: BadgeStateProps) {
  const colors = useMemo(() => {
    return {
      published: '#E8F8FF',
      finished: '#CEF0DA',
    };
  }, []);

  return (
    <>
      <div className="d-flex align-items-center justify-content-center student-degree-status-badge">
        <Badge
          className="status-badge fs-16 fw-400 py-2 px-4 text-dark"
          style={{ backgroundColor: colors[status], width: '90px' }}
          pill
        >
          {text}
        </Badge>
      </div>
    </>
  );
}
